import { getStore } from '../store/store';
import { WhatsNewCardStatus } from '../store/schema/WhatsNewCardStatus';

export function getUnreadWhatsNewCardCount(): number {
    let store = getStore();

    if (store.cards) {
        return Object.keys(store.cards).filter(
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (12,20): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'WhatsNewCardStatesMap'.
            // @ts-expect-error
            key => store.cards![key].status === WhatsNewCardStatus.Unread
        ).length;
    }

    return 0;
}
